<template>
    <div v-if="bizAuth.createPaperContract.hasRight" class="page-setting has-bc house-new-contract">
        <div class="page-header">
            <h1>
                {{$route.meta.title}}
                <word-tips-hover data="此情境用於您現在與租客已經有紙本租約，將線下收租模式改成線上收租。" width="424px"></word-tips-hover>
            </h1>
        </div>
        <new-contract></new-contract>
    </div>
</template>
<script>
import NewContract from '@/components/bussiness/mgtCategory/leaseMgt/newContract/NewContract.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';

import { mapGetters } from 'vuex'

export default {
    name: 'HouseManagement',
    data () {
        return {
            // houseFilter: false,
            listIsFixed: false,
        }
    },
    watch: {
        'bizAuth.createPaperContract.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        // window.addEventListener('scroll', this.handleScroll);
    },
    // destroyed() {
    //     window.removeEventListener('scroll', this.handleScroll);
    // },
    // methods: {
    //     handleScroll: function () {
    //         let scrollTop = event.target.documentElement.scrollTop
    //         console.log(scrollTop)
    //         if( scrollTop >= 50){
    //             document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
    //             document.getElementsByClassName('house-management')[0].style.zIndex = '8'
    //         }else{
    //             document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    //             document.getElementsByClassName('house-management')[0].style.zIndex = '9'
    //             this.listIsFixed = false
    //         }

    //         if( scrollTop >= 115){
    //             this.listIsFixed = true
    //         }
    //     },
    // },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        NewContract,
        wordTipsHover
    }
}
</script>
<style lang="scss" >
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/leaseMgt/newPaperContractFrame.vue